import mixpanel from "mixpanel-browser";
import { getPlatform, isAndroidTwa } from "Utils/Platform/PlatformUtils";

const MIXPANEL_CONFIG = {
  IS_ENABLED: import.meta.env.VITE_MIXPANEL_IS_ENABLED === "true",
  PROJECT_TOKEN: import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN as string,
  RECORD_SESSIONS_PERCENT: import.meta.env
    .VITE_MIXPANEL_RECORD_SESSIONS_PERCENT as number,
  IS_DEBUG_ENABLED: import.meta.env.VITE_MIXPANEL_IS_DEBUG_ENABLED === "true",
};

export function initMixpanel() {
  const projectToken = MIXPANEL_CONFIG.IS_ENABLED
    ? MIXPANEL_CONFIG.PROJECT_TOKEN
    : "null"; // init mixpanel with invalid token, so trying to send tracking events from the app won't crash it, as it would for uninitialized mixpanel

  mixpanel.init(projectToken, {
    debug: MIXPANEL_CONFIG.IS_DEBUG_ENABLED,
    track_pageview: true,
    api_host: "https://api-eu.mixpanel.com",
    autocapture: true,
    persistence: "localStorage",
    record_sessions_percent: MIXPANEL_CONFIG.RECORD_SESSIONS_PERCENT,
  });
}

export function disableMixpanel() {
  mixpanel.stop_session_recording();
  mixpanel.disable();
}

/**
 * How long the customer waited between tapping "Pay" and leaving for the bank's sign page. The bank is identified
 * by the sign page's host — the pay response carries no bank code. `startedAt` is a `performance.now()` reading
 * taken when the pay request started; null when it was not captured.
 */
export function trackPayRedirectToBank(
  signingUrl: string,
  startedAt: number | null,
) {
  let signingHost = "unknown";
  try {
    signingHost = new URL(signingUrl).host;
  } catch {
    // A bank URL we cannot parse is still worth counting under "unknown".
  }

  mixpanel.track("Pay Redirect To Bank", {
    signingHost,
    // The legacy TWA reports "web" from Capacitor; it opens the bank in the same Chrome tab, unlike the shells.
    platform: isAndroidTwa() ? "android-twa" : getPlatform(),
    durationMs:
      startedAt === null ? null : Math.round(performance.now() - startedAt),
  });
}
